import { ElementRef, EventEmitter, NgZone, QueryList, } from '@angular/core';
import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { defer, from, of, timer } from 'rxjs';
import { catchError, finalize, map, mergeMap, shareReplay, takeUntil, timeout } from 'rxjs/operators';
import Sortable from 'sortablejs';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setSections } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/sections/sections.actions';
import { setSelectedReportWizardSteps } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getIsEdited } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/custom-pdf-report-builder.selector';
import { getAllSecurities, getComparisonSecurities, getCurrentWizardStep, getCurrentWizardStepIndex, getCustomPDFReportParamsSections, getNamingConvention, getPrimarySecurity, getRequestedSectionOrder, getSecondarySecurity, getSections, getSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY, TargetSecurityChoice, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/constants';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import { CustomPDFReportType } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-type.enum';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { ReportNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/naming-convention.enum';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { CustomPDFReportModulePreviewImageService, } from 'CustomPDFReportsApp/ts/services/custom-pdf-report-module-preview-image.service';
import { HelpModalWithTriggerComponent } from 'Angular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { disablePointerEvents, enablePointerEvents } from 'Angular/utils/sortable-utils';
import { convertModulesToSaveState, getSortedModulePages, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/utils/custom-pdf-report-builder-utils';
import { getModuleIdentityKey } from 'CustomPDFReportsApp/ts/utils/custom-pdf-report-utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i3 from "CustomPDFReportsApp/ts/services/custom-pdf-report-module-preview-image.service";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal-with-trigger.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i11 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-sections-modal/preview-sections-modal/preview-sections-modal.component";
const _c0 = ["sectionsContainer"];
const _c1 = ["orphanModulesHelpTrigger"];
const _c2 = ["reorderButton"];
const _forTrack0 = ($index, $item) => $item.clientId;
function SelectSectionsModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span", 27);
    i0.ɵɵtext(2, "Section ordering has been locked by the report owner. Sections will render in the default order.");
    i0.ɵɵelementEnd()();
} }
function SelectSectionsModalComponent_For_20_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35, 2);
    i0.ɵɵlistener("keydown", function SelectSectionsModalComponent_For_20_Conditional_7_Template_button_keydown_0_listener($event) { i0.ɵɵrestoreView(_r4); const ɵ$index_36_r5 = i0.ɵɵnextContext().$index; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onReorderKeydown($event, ɵ$index_36_r5)); })("focus", function SelectSectionsModalComponent_For_20_Conditional_7_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r4); const section_r3 = i0.ɵɵnextContext().$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.focusedSection = section_r3); })("blur", function SelectSectionsModalComponent_For_20_Conditional_7_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.focusedSection = null); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const section_r3 = ctx_r6.$implicit;
    const ɵ$index_36_r5 = ctx_r6.$index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", ctx_r5.grabbedIndex === ɵ$index_36_r5 ? "#e5f2fc" : null)("outline", ctx_r5.focusedSection === section_r3 ? "1px solid #c0dff9" : "none");
    i0.ɵɵclassProp("active", ctx_r5.grabbedIndex === ɵ$index_36_r5);
    i0.ɵɵproperty("tooltipTitle", "Reorder (space to grab, arrow keys to move)");
    i0.ɵɵattribute("aria-label", (ctx_r5.grabbedIndex === ɵ$index_36_r5 ? "Drop " : "Reorder ") + section_r3.title)("aria-pressed", ctx_r5.grabbedIndex === ɵ$index_36_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-reorder-up");
} }
function SelectSectionsModalComponent_For_20_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 28)(2, "label", 29)(3, "input", 30);
    i0.ɵɵtwoWayListener("ngModelChange", function SelectSectionsModalComponent_For_20_Template_input_ngModelChange_3_listener($event) { const section_r3 = i0.ɵɵrestoreView(_r2).$implicit; i0.ɵɵtwoWayBindingSet(section_r3.selected, $event) || (section_r3.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 31)(5, "span", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 33);
    i0.ɵɵconditionalCreate(7, SelectSectionsModalComponent_For_20_Conditional_7_Template, 3, 10, "button", 34);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const section_r3 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-client-id", section_r3.clientId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", section_r3.required ? ctx_r5.requiredTooltipTitle : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", section_r3.required);
    i0.ɵɵtwoWayProperty("ngModel", section_r3.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", section_r3.title);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r5.allowSectionOrdering ? 7 : -1);
} }
function SelectSectionsModalComponent_Conditional_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, "Unable to save section preferences. Please try again.");
    i0.ɵɵelementEnd();
} }
function SelectSectionsModalComponent_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, "Unable to apply your section selections. Please try again.");
    i0.ɵɵelementEnd();
} }
function SelectSectionsModalComponent_Conditional_24_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, "Unable to load saved section preferences. ");
    i0.ɵɵelementStart(2, "a", 37);
    i0.ɵɵlistener("click", function SelectSectionsModalComponent_Conditional_24_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.retryPreferenceFetch()); });
    i0.ɵɵtext(3, "Retry");
    i0.ɵɵelementEnd()();
} }
function SelectSectionsModalComponent_Conditional_28_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵlistener("click", function SelectSectionsModalComponent_Conditional_28_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.back()); });
    i0.ɵɵtext(1, "Back");
    i0.ɵɵelementEnd();
} }
function SelectSectionsModalComponent_Conditional_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "div", 39);
    i0.ɵɵelementEnd();
} }
const PREVIEWABLE_REPORT_TYPES = new Set(Object.values(CustomPDFReportType));
export class SelectSectionsModalComponent {
    constructor(store, 
    // Typed loosely (reportBuilder optional) since this modal is also opened from apps that
    // never register the builder's NgRx feature -- there, this key is a same-named but
    // differently-shaped root state, not the builder's, so `reportBuilder` is genuinely absent.
    builderStore, ngZone, customPDFReportService, customPDFReportModulePreviewImageService) {
        this.store = store;
        this.builderStore = builderStore;
        this.ngZone = ngZone;
        this.customPDFReportService = customPDFReportService;
        this.customPDFReportModulePreviewImageService = customPDFReportModulePreviewImageService;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.modalOpen = false;
        this.grabbedIndex = null;
        this.focusedSection = null;
        this.liveMessage = '';
        this.currentWizardStepIndex = 0;
        this.currentWizardStep = null;
        this.sections = [];
        this.requiredTooltipTitle = 'This content is required by your administrator';
        this.restoreDefaultsButtonText = 'Restore Defaults';
        this.submitError = false;
        this.isSubmitting = false;
        this.hasOrphanModules = false;
        this.allowSectionOrdering = true;
        this.isLoadingPreference = false;
        this.preferenceFetchError = false;
        this.isRestoringDefaults = false;
        this.hasShownOrphanModulesWarning = false;
        // Whether `hasOrphanModules` reflects a known value yet (live state or a resolved GET).
        this.sectionPreferenceLoaded = false;
        // Set when a reorder is attempted before `sectionPreferenceLoaded`; replayed once known.
        this.orphanWarningPendingCheck = false;
        // True when generating from the builder app with edits made there since the last save --
        // Preview would otherwise silently show the last-saved module content instead. Stays false
        // when opened from a context with no builder store to read (e.g. the reports list app), since
        // there's no such thing as unsaved builder edits there.
        this.hasUnsavedBuilderEdits = false;
        // True while Next is re-deriving the wizard steps for the sections the user kept.
        this.isRecomputingWizardSteps = false;
        this.wizardStepsError = false;
        // Live (possibly unsaved) builder modules; null when not generating from the builder.
        this.builderModules = null;
        this.wizardSteps = [];
        // Whether a previous pass through this modal narrowed the steps now in state.
        this.hasNarrowedWizardSteps = false;
        // The section visibility and order this step was last answered with, if it has an answer.
        this.answeredSections = [];
        this.answeredSectionOrder = [];
        // Seeded once per report, so Back/Next keeps the selection the user is working on.
        this.hasSeededFromAnsweredSections = false;
        // Whether the launch context stripped the analysis plan step from the wizard we started from.
        this.launchContextDroppedAnalysisPlanStep = false;
        this.storeSectionsKey = '';
        // Incremented on every openModal() call so restoreDefaults()'s DELETE callback (left
        // subscribed across a close) can detect a response that arrives after a reopen.
        this.modalSessionId = 0;
        // The in-flight Restore Defaults DELETE, if any, and the report it targets. A reopen must wait
        // for this to settle before fetching preferences, or its GET could win the race and load the
        // row the DELETE is about to remove.
        this.pendingDeleteReportId = null;
        this.pendingDelete$ = null;
        // All sections shown, in the report's own order.
        this.defaultSections = [];
        // The sections state as loaded (or last persisted), used to detect changes on forward().
        this.baselineSections = [];
        this.reportId = null;
        // Live (possibly unsaved) orphan-modules state from the builder, if generating from there;
        // when set, the section-preference GET's `has_orphan_modules` is ignored.
        this.liveHasOrphanModules = undefined;
        this.reportOrientation = CustomPDFReportOrientation.PORTRAIT;
        this.reportType = null;
        this.previewOpen = false;
        this.previewLoading = false;
        this.previewError = false;
        this.previewModules = [];
        this.previewSecurityIds = [];
        this.previewCustomLabels = [];
        this.previewNamingConvention = ReportNamingConvention.TRUNCATED;
        this.previewDataSource = undefined;
        this.previewLanguage = undefined;
        // Used by getModuleSecurities() to match the builder canvas's per-module cache key.
        this.primarySecurity = null;
        this.secondarySecurity = null;
        this.comparisonSecurities = [];
        // Discards a stale preview response; incremented per request rather than keyed by report id, since
        // two Preview clicks on the same report aren't otherwise distinguishable.
        this.previewRequestId = 0;
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            const selectedReport = getSelectedReport(state);
            this.reportId = 'report_id' in selectedReport ? selectedReport.report_id : null;
            this.liveHasOrphanModules =
                'has_orphan_modules' in selectedReport ? selectedReport.has_orphan_modules : undefined;
            this.allowSectionOrdering =
                'allow_section_ordering' in selectedReport ? selectedReport.allow_section_ordering : true;
            this.reportOrientation =
                selectedReport.report_orientation || CustomPDFReportOrientation.PORTRAIT;
            this.reportType = selectedReport.report_type || null;
            this.wizardSteps = selectedReport.wizard_steps || [];
            this.previewDataSource = selectedReport.data_source || undefined;
            this.previewLanguage = selectedReport.language || undefined;
            const allSecurities = getAllSecurities(state);
            this.previewSecurityIds = allSecurities
                .filter((security) => security.securityId)
                .map((security) => security.securityId);
            this.previewCustomLabels = allSecurities
                .filter((security) => security.customLabel)
                .map((security) => security.customLabel);
            this.previewNamingConvention = getNamingConvention(state);
            this.primarySecurity = getPrimarySecurity(state);
            this.secondarySecurity = getSecondarySecurity(state);
            this.comparisonSecurities = getComparisonSecurities(state);
            const sections = getSections(state);
            this.answeredSections = getCustomPDFReportParamsSections(state);
            this.answeredSectionOrder = getRequestedSectionOrder(state);
            // Unsaved sections have no persisted id, so fall back to a positional identifier -
            // otherwise every unsaved section would collapse onto the same key.
            const sectionsKey = `${this.reportId ?? 'new'}:${sections
                .map((section, index) => section.id ?? `new-${index}`)
                .sort()
                .join(',')}`;
            if (sectionsKey !== this.storeSectionsKey) {
                this.storeSectionsKey = sectionsKey;
                this.grabbedIndex = null;
                this.hasNarrowedWizardSteps = false;
                this.hasSeededFromAnsweredSections = false;
                this.defaultSections = sections.map((section, index) => {
                    return {
                        ...section,
                        selected: true,
                        clientId: section.id !== undefined ? String(section.id) : `new-${index}`,
                    };
                });
                this.sections = cloneDeep(this.defaultSections);
                this.baselineSections = cloneDeep(this.defaultSections);
            }
            // A report selection dispatches twice, so this sits outside the per-report block above to
            // see the second, launch-context-filtered copy. Frozen once this modal narrows the wizard.
            if (!this.hasNarrowedWizardSteps) {
                this.launchContextDroppedAnalysisPlanStep =
                    !!this.wizardSteps.length &&
                        !this.wizardSteps.some((step) => step.eventName === CustomPDFReportModalEventName.SHOW_SELECT_INTERACTIVE_ANALYSIS_MODAL);
            }
            if (!this.modalOpen &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_SECTIONS_MODAL) {
                this.openModal();
            }
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
        this.builderStoreSubscription = this.builderStore
            .select((state) => state.reducers?.[CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY])
            .subscribe((reportBuilderState) => {
            this.hasUnsavedBuilderEdits = reportBuilderState ? getIsEdited(reportBuilderState) : false;
            this.builderModules = reportBuilderState?.report?.modules ?? null;
        });
    }
    ngAfterViewInit() {
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.sectionsContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onStart: () => {
                    this.ngZone.run(() => {
                        this.grabbedIndex = null;
                        this.maybeShowOrphanModulesWarning();
                    });
                    disablePointerEvents(document, 'section-row');
                },
                onUpdate: (event) => {
                    this.ngZone.run(() => {
                        this.sections.splice(event.newIndex, 0, this.sections.splice(event.oldIndex, 1)[0]);
                    });
                },
                onEnd: (event) => {
                    enablePointerEvents(document, 'section-row');
                    // This is a workaround for a bug in the Sortable library which can recheck
                    // unchecked items after dragging. There is no entrypoint provided by SortableJS
                    // after it updates the checkbox state, so we need to delay execution.
                    setTimeout(() => {
                        const { children } = event.target;
                        this.sections.forEach((section) => {
                            for (let i = 0; i < children.length; i += 1) {
                                const child = children[i];
                                if (section.clientId === child.dataset.clientId) {
                                    const input = child.getElementsByClassName('custom-control-input')[0];
                                    if (input && input.checked !== section.selected) {
                                        input.checked = section.selected;
                                    }
                                }
                            }
                        });
                    });
                },
            });
        });
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
        this.builderStoreSubscription.unsubscribe();
        if (this.putSubscription) {
            this.putSubscription.unsubscribe();
        }
        if (this.getSubscription) {
            this.getSubscription.unsubscribe();
        }
        this.wizardStepsSubscription?.unsubscribe();
        if (this.previewSectionsSubscription) {
            this.previewSectionsSubscription.unsubscribe();
        }
        if (this.previewImagesSubscription) {
            this.previewImagesSubscription.unsubscribe();
        }
    }
    onReorderKeydown(event, index) {
        const section = this.sections[index];
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            if (this.grabbedIndex === index) {
                this.grabbedIndex = null;
                this.liveMessage = `${section.title} dropped at position ${index + 1} of ${this.sections.length}.`;
            }
            else {
                this.grabbedIndex = index;
                this.liveMessage = `${section.title} grabbed. Use up and down arrow keys to move, space to drop.`;
                this.maybeShowOrphanModulesWarning();
            }
            return;
        }
        if (this.grabbedIndex !== index) {
            return;
        }
        let targetIndex;
        if (event.key === 'ArrowUp') {
            targetIndex = index - 1;
        }
        else if (event.key === 'ArrowDown') {
            targetIndex = index + 1;
        }
        else {
            return;
        }
        event.preventDefault();
        if (targetIndex < 0 || targetIndex >= this.sections.length) {
            return;
        }
        this.sections.splice(targetIndex, 0, this.sections.splice(index, 1)[0]);
        this.grabbedIndex = targetIndex;
        this.liveMessage = `${section.title} moved to position ${targetIndex + 1} of ${this.sections.length}.`;
        // NgFor detaches/reinserts the row's view on reorder, which drops focus from the handle.
        setTimeout(() => {
            const button = this.reorderButtons?.toArray()[targetIndex];
            if (button) {
                button.nativeElement.focus();
            }
        });
    }
    openModal() {
        if (this.modalOpen) {
            return;
        }
        this.modalSessionId += 1;
        this.modalOpen = true;
        this.grabbedIndex = null;
        this.liveMessage = '';
        this.submitError = false;
        this.wizardStepsError = false;
        this.hasShownOrphanModulesWarning = false;
        this.orphanWarningPendingCheck = false;
        // A prior session's `finalize` only clears this for a matching session id, so a reopen
        // during an in-flight restore would otherwise leave Next disabled indefinitely.
        this.isRestoringDefaults = false;
        if (this.liveHasOrphanModules !== undefined) {
            this.hasOrphanModules = this.liveHasOrphanModules;
            this.sectionPreferenceLoaded = true;
        }
        else {
            this.hasOrphanModules = false;
            this.sectionPreferenceLoaded = false;
        }
        this.seedFromAnsweredSections();
        const sessionReportId = this.reportId;
        this.preferenceFetchError = false;
        // Locked reports and unsaved reports/sections have nothing to fetch preferences for.
        if (!this.isPersistableContext() || !this.allowSectionOrdering) {
            return;
        }
        // A prior session's Restore Defaults DELETE may still be in flight for this report;
        // wait for it to settle before fetching, so this doesn't win the race and load the row
        // the DELETE is about to remove.
        if (this.pendingDeleteReportId === this.reportId && this.pendingDelete$) {
            this.isLoadingPreference = true;
            this.pendingDelete$.subscribe({
                next: () => this.fetchSectionPreference(sessionReportId),
                error: () => {
                    this.isLoadingPreference = false;
                    this.preferenceFetchError = true;
                },
            });
            return;
        }
        this.fetchSectionPreference(sessionReportId);
    }
    retryPreferenceFetch() {
        this.fetchSectionPreference();
    }
    restoreDefaults() {
        if (!this.isPersistableContext() || !this.allowSectionOrdering) {
            this.sections = cloneDeep(this.defaultSections);
            this.baselineSections = cloneDeep(this.defaultSections);
            this.submitError = false;
            return;
        }
        // A pending GET would otherwise apply a stale preference after this restore completes.
        this.getSubscription?.unsubscribe();
        // Deliberately not tracked/unsubscribed in closeModal(): unlike GET/PUT, unsubscribing an
        // in-flight HttpClient DELETE would abort it, stopping Restore Defaults from actually
        // deleting the preference. Since it can resolve after the modal is closed and reopened,
        // capture the session id and require it to still match.
        const sessionId = this.modalSessionId;
        const reportId = this.reportId;
        this.pendingDeleteReportId = reportId;
        this.isRestoringDefaults = true;
        // shareReplay so openModal() can await this same in-flight request (rather than firing a
        // second DELETE) if the modal is reopened before it resolves.
        this.pendingDelete$ = this.customPDFReportService.deleteSectionPreference(reportId).pipe(finalize(() => {
            if (this.pendingDeleteReportId === reportId) {
                this.pendingDeleteReportId = null;
                this.pendingDelete$ = null;
            }
        }), shareReplay(1));
        this.pendingDelete$.subscribe({
            next: () => {
                if (sessionId === this.modalSessionId) {
                    this.isRestoringDefaults = false;
                }
                if (!this.modalOpen || sessionId !== this.modalSessionId) {
                    return;
                }
                this.sections = cloneDeep(this.defaultSections);
                this.baselineSections = cloneDeep(this.defaultSections);
                this.submitError = false;
            },
            // pendingDelete$ is shared, so this handles the error here (for the original session)
            // rather than leaving it unhandled for RxJS to report as an unhandled exception.
            error: () => {
                if (sessionId === this.modalSessionId) {
                    this.isRestoringDefaults = false;
                }
                if (this.modalOpen && sessionId === this.modalSessionId) {
                    this.submitError = true;
                }
            },
        });
    }
    fetchSectionPreference(sessionReportId = this.reportId) {
        this.isLoadingPreference = true;
        this.preferenceFetchError = false;
        this.getSubscription = this.customPDFReportService.getSectionPreference(this.reportId).subscribe({
            next: (response) => {
                this.isLoadingPreference = false;
                // The modal is mounted persistently across report selections; discard a response
                // for a report the user is no longer viewing.
                if (!this.modalOpen || this.reportId !== sessionReportId) {
                    return;
                }
                if (this.liveHasOrphanModules === undefined) {
                    this.hasOrphanModules = response.has_orphan_modules;
                    this.sectionPreferenceLoaded = true;
                    if (this.orphanWarningPendingCheck) {
                        this.orphanWarningPendingCheck = false;
                        this.maybeShowOrphanModulesWarning();
                    }
                }
                // Fetched for its orphan-modules flag, but it can't stand in for an existing answer.
                if (this.hasSeededFromAnsweredSections) {
                    return;
                }
                // Don't clobber edits the user already made while this was in flight.
                if (!this.sectionsMatchBaseline()) {
                    return;
                }
                this.applyPreferenceSections(response.sections);
                this.baselineSections = cloneDeep(this.sections);
            },
            error: () => {
                this.isLoadingPreference = false;
                if (!this.modalOpen) {
                    return;
                }
                this.preferenceFetchError = true;
            },
        });
    }
    // An unsaved report, or one with unsaved sections, has nothing for the preference API to key off of.
    isPersistableContext() {
        return !!this.reportId && this.sections.every((section) => section.id !== undefined);
    }
    /**
     * Shows the visibility and order this step was already answered with, so a regenerated report
     * presents the copy that was generated. The preference is a rolling per-report default that
     * every generation overwrites, so it may describe a different copy entirely.
     */
    seedFromAnsweredSections() {
        if (this.hasSeededFromAnsweredSections || !this.answeredSections.length) {
            return;
        }
        this.hasSeededFromAnsweredSections = true;
        const hiddenByClientId = new Map(this.answeredSections.map((section) => [
            section.id !== undefined ? String(section.id) : section.key,
            section.hidden,
        ]));
        // A section the answer doesn't mention is new, so it stays included. Required sections
        // can't be turned off whatever the answer says.
        const seededSections = this.defaultSections.map((section) => ({
            ...section,
            selected: section.required || !hiddenByClientId.get(section.clientId),
        }));
        const seededByClientId = new Map(seededSections.map((section) => [section.clientId, section]));
        const orderedSections = this.answeredSectionOrder
            .filter((clientId) => seededByClientId.has(clientId))
            .map((clientId) => seededByClientId.get(clientId));
        const orderedClientIds = new Set(orderedSections.map((section) => section.clientId));
        this.sections = [
            ...orderedSections,
            ...seededSections.filter((section) => !orderedClientIds.has(section.clientId)),
        ];
        this.baselineSections = cloneDeep(this.sections);
        // The replayed steps were narrowed for this answer, so re-including a section re-derives them.
        this.hasNarrowedWizardSteps = this.sections.some((section) => !section.selected);
        this.launchContextDroppedAnalysisPlanStep = false;
    }
    applyPreferenceSections(preferenceSections) {
        if (!preferenceSections?.length) {
            this.sections = cloneDeep(this.defaultSections);
            return;
        }
        const defaultById = new Map(this.defaultSections.map((section) => [section.id, section]));
        const orderedSections = preferenceSections
            .filter((entry) => defaultById.has(entry.section_id))
            .map((entry) => ({ ...defaultById.get(entry.section_id), selected: !entry.hidden }));
        const orderedIds = new Set(orderedSections.map((section) => section.id));
        const missingSections = this.defaultSections.filter((section) => !orderedIds.has(section.id));
        this.sections = [...orderedSections, ...missingSections];
    }
    maybeShowOrphanModulesWarning() {
        if (this.hasShownOrphanModulesWarning) {
            return;
        }
        if (!this.sectionPreferenceLoaded) {
            // hasOrphanModules isn't known yet; replay this check once it is.
            this.orphanWarningPendingCheck = true;
            return;
        }
        if (!this.hasOrphanModules) {
            return;
        }
        this.hasShownOrphanModulesWarning = true;
        // Release the section being grabbed/dragged so the popup isn't left blocking a still-active
        // reorder -- keyboard users would otherwise keep moving the row behind the modal.
        this.grabbedIndex = null;
        this.liveMessage = '';
        if (this.orphanModulesHelpTrigger) {
            this.orphanModulesHelpTrigger.open();
        }
    }
    sectionsMatchBaseline() {
        if (this.sections.length !== this.baselineSections.length) {
            return false;
        }
        return this.sections.every((section, index) => {
            const baselineSection = this.baselineSections[index];
            return section.id === baselineSection.id && section.selected === baselineSection.selected;
        });
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    closeModal() {
        // Unsubscribing (rather than blocking Cancel/Back on an in-flight request) prevents a
        // stale response from acting on a closed/reused modal. Note this doesn't cancel a PUT
        // server-side, so the section-visibility preference may still be persisted.
        if (this.putSubscription) {
            this.putSubscription.unsubscribe();
        }
        if (this.getSubscription) {
            this.getSubscription.unsubscribe();
        }
        this.wizardStepsSubscription?.unsubscribe();
        if (this.previewSectionsSubscription) {
            this.previewSectionsSubscription.unsubscribe();
        }
        if (this.previewImagesSubscription) {
            this.previewImagesSubscription.unsubscribe();
        }
        // The Restore Defaults DELETE is intentionally not tracked/unsubscribed here - see the
        // comment in restoreDefaults().
        this.modalOpen = false;
        this.grabbedIndex = null;
        this.liveMessage = '';
        this.isSubmitting = false;
        this.isRecomputingWizardSteps = false;
        this.isLoadingPreference = false;
    }
    back() {
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.closeModal();
    }
    get previewDisabledReason() {
        if (!this.reportId) {
            return 'Save the report to preview it';
        }
        // TODO: re-enable this once the builder's `isEdited`/getIsEdited flag is fixed -- it's
        // currently a false positive for any report with sections+modules opened by a user with
        // the LEGACY_DATA feature (getSectionsWithModules recomputes module y_coordinate into
        // global units for the live saveParams, but prev_save_params keeps the raw page-local
        // value from the API, so they never match on load) and reportedly a false negative for at
        // least one saved-report-with-real-edits scenario. See `hasUnsavedBuilderEdits` below.
        // if (this.hasUnsavedBuilderEdits) {
        //     return 'Save your changes to preview them';
        // }
        if (this.primarySecurity?.securityListGroup) {
            return 'Preview is not available for a security list';
        }
        if (this.reportType && !PREVIEWABLE_REPORT_TYPES.has(this.reportType)) {
            return 'Preview is not available for this report type';
        }
        return '';
    }
    preview() {
        if (!this.reportId || !!this.previewDisabledReason || !this.reportType || this.previewLoading) {
            return;
        }
        this.previewOpen = true;
        this.previewLoading = true;
        this.previewError = false;
        this.previewModules = [];
        this.previewRequestId += 1;
        const requestId = this.previewRequestId;
        const selectedByKey = new Map(this.sections.map((section) => [section.clientId, section.selected]));
        const sections = this.defaultSections.map((section) => ({
            id: section.id,
            key: section.clientId,
            modules: section.modules,
            hidden: !(selectedByKey.get(section.clientId) ?? true),
        }));
        if (this.previewSectionsSubscription) {
            this.previewSectionsSubscription.unsubscribe();
        }
        this.previewSectionsSubscription = this.customPDFReportModulePreviewImageService
            .getPDFReportSectionsPreviewImages(this.reportType, this.reportId, sections, {
            security_ids: this.previewSecurityIds,
            custom_labels: this.previewCustomLabels,
            naming_convention: this.previewNamingConvention,
            requested_section_order: this.getRequestedSectionOrder(),
        })
            .pipe(timeout(30000))
            .subscribe({
            next: ({ modules }) => {
                if (!this.previewOpen || this.previewRequestId !== requestId) {
                    return;
                }
                this.fetchLiveModuleImages(modules, requestId);
            },
            error: () => {
                if (!this.previewOpen || this.previewRequestId !== requestId) {
                    return;
                }
                this.previewLoading = false;
                this.previewError = true;
            },
        });
    }
    // Each live-previewable module's image is fetched separately, through the same cached endpoint the
    // module editor uses -- keyed by rendering parameters, not by saved module id, so unaffected modules
    // stay cached across a section toggle.
    fetchLiveModuleImages(modules, requestId) {
        const liveModules = modules.filter((module) => module.can_live_preview);
        if (!liveModules.length) {
            this.previewLoading = false;
            this.previewModules = modules;
            return;
        }
        const imageRequests = liveModules.map((module) => {
            const moduleSecurities = this.getModuleSecurities(module);
            const moduleSecurityIds = moduleSecurities
                .filter((security) => security.securityId)
                .map((security) => security.securityId);
            const moduleCustomLabels = this.previewNamingConvention === ReportNamingConvention.CUSTOM
                ? moduleSecurities
                    .filter((security) => security.customLabel)
                    .map((security) => security.customLabel)
                : [];
            return defer(() => this.customPDFReportModulePreviewImageService.getPDFReportModulePreviewImage(module.report_type, {
                module_type: module.module_type,
                customizable_fields: module.customizable_fields ?? {},
                security_ids: moduleSecurityIds,
                report_id: this.reportId,
                naming_convention: this.previewNamingConvention,
                custom_labels: moduleCustomLabels,
                report_orientation: this.reportOrientation,
                data_source: this.previewDataSource,
                language: this.previewLanguage,
            })).pipe(timeout(30000), map(({ imageUrls, warning }) => ({ ...module, imageUrls, warning })), catchError(() => of({ ...module, imageUrls: [], error: 'Unable to load preview.' })));
        });
        if (this.previewImagesSubscription) {
            this.previewImagesSubscription.unsubscribe();
        }
        const liveResultsByKey = new Map();
        // Bounded concurrency -- a large report can have dozens of live-previewable modules, and each
        // request can itself fan out into multiple render workers server-side. Each request also has
        // its own timeout() above, but that alone still lets a stalled report take
        // ceil(liveModules.length / 6) * 30s to finish -- takeUntil() caps the whole batch instead, so
        // a large report can't leave the spinner running for minutes.
        this.previewImagesSubscription = from(imageRequests)
            .pipe(mergeMap((imageRequest) => imageRequest, 6), takeUntil(timer(60000)))
            .subscribe({
            next: (result) => {
                if (!this.previewOpen || this.previewRequestId !== requestId) {
                    return;
                }
                liveResultsByKey.set(`${result.module_id}_${result.module_type}`, result);
                this.previewModules = modules.map((module) => liveResultsByKey.get(`${module.module_id}_${module.module_type}`) ?? module);
            },
            complete: () => {
                if (!this.previewOpen || this.previewRequestId !== requestId) {
                    return;
                }
                this.previewLoading = false;
                // Modules the 60s deadline above cut off before their own request resolved.
                this.previewModules = modules.map((module) => {
                    const result = liveResultsByKey.get(`${module.module_id}_${module.module_type}`);
                    if (result) {
                        return result;
                    }
                    return module.can_live_preview
                        ? { ...module, imageUrls: [], error: 'Unable to load preview.' }
                        : module;
                });
            },
        });
    }
    // Mirrors custom-pdf-report-module.component.ts's getSecurities() for cache-key parity.
    getModuleSecurities(module) {
        const effectiveSecondarySecurity = this.secondarySecurity?.securityId
            ? this.secondarySecurity
            : this.comparisonSecurities[0];
        switch (module.report_type) {
            case CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW:
                if (module.customizable_fields?.target_security_choice === TargetSecurityChoice.SECONDARY_SECURITY) {
                    return [this.primarySecurity, effectiveSecondarySecurity].filter((security) => !!security);
                }
                return this.primarySecurity ? [this.primarySecurity] : [];
            case CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON:
                return [this.primarySecurity, effectiveSecondarySecurity].filter((security) => !!security);
            case CustomPDFReportType.MULTI_SECURITY_COMPARISON:
                return this.primarySecurity ? [this.primarySecurity, ...this.comparisonSecurities] : [];
            default:
                return [];
        }
    }
    closePreview() {
        this.previewOpen = false;
        // Unlock preview() rather than waiting on a request the user already dismissed.
        this.previewLoading = false;
        if (this.previewSectionsSubscription) {
            this.previewSectionsSubscription.unsubscribe();
        }
        if (this.previewImagesSubscription) {
            this.previewImagesSubscription.unsubscribe();
        }
    }
    forward() {
        if (this.isSubmitting || this.isRestoringDefaults || this.isRecomputingWizardSteps) {
            return;
        }
        this.submitError = false;
        this.wizardStepsError = false;
        if (this.sectionsMatchBaseline() || !this.allowSectionOrdering) {
            this.advanceWizardStep();
            return;
        }
        if (!this.isPersistableContext()) {
            this.baselineSections = cloneDeep(this.sections);
            this.advanceWizardStep();
            return;
        }
        const submittedSections = cloneDeep(this.sections);
        const putParams = {
            sections: submittedSections.map((section) => ({
                section_id: section.id,
                hidden: !section.selected,
            })),
        };
        this.isSubmitting = true;
        this.putSubscription = this.customPDFReportService.putSectionPreference(this.reportId, putParams).subscribe({
            next: () => {
                this.isSubmitting = false;
                if (!this.modalOpen) {
                    return;
                }
                this.baselineSections = submittedSections;
                this.advanceWizardStep();
            },
            error: () => {
                this.isSubmitting = false;
                if (!this.modalOpen) {
                    return;
                }
                this.submitError = true;
            },
        });
    }
    /** Returns section keys in the user's requested order, or `[]` when there's no reorder to apply. */
    getRequestedSectionOrder() {
        if (!this.allowSectionOrdering) {
            return [];
        }
        const requestedKeys = this.sections.map((section) => section.clientId);
        const defaultKeys = this.defaultSections.map((section) => section.clientId);
        const isDefaultOrder = requestedKeys.length === defaultKeys.length &&
            requestedKeys.every((key, index) => key === defaultKeys[index]);
        return isDefaultOrder ? [] : requestedKeys;
    }
    /**
     * Positions in `sortedModules` of the modules the user left out -- the same list that is sent to
     * the wizard steps endpoint, so the indexes line up with what the server enumerates. A module in
     * any hidden section is left out even when another, kept section also claims it.
     */
    getExcludedModuleIndexes(sortedModules) {
        const hiddenKeys = new Set(this.sections
            .filter((section) => !section.selected)
            .flatMap((section) => section.modules)
            .map(getModuleIdentityKey));
        return sortedModules.flatMap((module, index) => (hiddenKeys.has(getModuleIdentityKey(module)) ? [index] : []));
    }
    /** Ids of the sections the user left out, or `null` when any of them was never saved. */
    getHiddenSectionIds() {
        if (this.sections.some((section) => section.id === undefined)) {
            return null;
        }
        return this.sections.filter((section) => !section.selected).map((section) => section.id);
    }
    advanceWizardStep() {
        const selectedByKey = new Map(this.sections.map((section) => [section.clientId, section.selected]));
        this.store.dispatch(setSections({
            sections: this.defaultSections.map((section) => {
                return {
                    id: section.id,
                    key: section.clientId,
                    title: section.title,
                    modules: section.modules,
                    hidden: !(selectedByKey.get(section.clientId) ?? true),
                };
            }),
            requestedSectionOrder: this.getRequestedSectionOrder(),
        }));
        const narrowing = this.getWizardStepNarrowing();
        if (!narrowing) {
            this.store.dispatch(incrementCurrentWizardStep());
            this.finishWizardStep();
            return;
        }
        this.recomputeWizardSteps(narrowing);
    }
    /**
     * A request for the wizard steps that ask only about the modules the report still contains,
     * paired with whether it actually leaves anything out. `null` when the steps in state already
     * match -- nothing is left out, and nothing was left out on a previous pass through this modal.
     *
     * The builder holds unsaved modules, so it sends the module list and their positions; a saved
     * report is narrowed by section id, which the server already maps to modules.
     */
    getWizardStepNarrowing() {
        // A locked report generates with every section visible, so nothing is left out to narrow by.
        if (!this.allowSectionOrdering) {
            return null;
        }
        const hasHiddenSections = this.sections.some((section) => !section.selected);
        if (!hasHiddenSections && !this.hasNarrowedWizardSteps) {
            return null;
        }
        if (this.builderModules && this.reportType) {
            // Sorted once: the payload and the indexes into it have to come from the same list.
            const sortedPages = getSortedModulePages(this.builderModules);
            const excludedModuleIndexes = this.getExcludedModuleIndexes(sortedPages.flat());
            return {
                steps$: this.customPDFReportService.getWizardStepsFromModules(convertModulesToSaveState(sortedPages).flat(), this.reportType, this.reportOrientation, true, this.previewDataSource, excludedModuleIndexes),
                isNarrowed: !!excludedModuleIndexes.length,
            };
        }
        const hiddenSectionIds = this.getHiddenSectionIds();
        if (!this.reportId || hiddenSectionIds === null) {
            return null;
        }
        return {
            steps$: this.customPDFReportService.getSavedReportWizardSteps(this.reportId, hiddenSectionIds),
            isNarrowed: !!hiddenSectionIds.length,
        };
    }
    /**
     * Keeps the steps up to and including this one exactly as the wizard walked the user through
     * them -- the security search step's saved-asset fields, an Export Options step inserted when
     * the user picked a security list -- since those are already answered. Only the tail changes,
     * which leaves this step's index (and so the wizard's position) alone.
     */
    mergeWizardSteps(narrowedSteps) {
        const isSectionsStep = (step) => step.eventName === CustomPDFReportModalEventName.SHOW_SELECT_SECTIONS_MODAL;
        const currentIndex = this.wizardSteps.findIndex(isSectionsStep);
        const narrowedIndex = narrowedSteps.findIndex(isSectionsStep);
        if (currentIndex === -1 || narrowedIndex === -1) {
            return narrowedSteps;
        }
        // The risk profile step only sits ahead of Security Selection while the model portfolio
        // picker is on the report, so hiding the picker's section demotes it into the narrowed
        // tail -- where it would ask again for something the preserved steps already answered.
        const kept = this.wizardSteps.slice(0, currentIndex + 1);
        const answeredEventNames = new Set(kept.map((step) => step.eventName));
        // Launching from a saved analysis plan drops the plan selector; re-deriving brings it back,
        // so drop it again.
        const isStepStillWanted = (step) => !answeredEventNames.has(step.eventName) &&
            !(this.launchContextDroppedAnalysisPlanStep &&
                step.eventName === CustomPDFReportModalEventName.SHOW_SELECT_INTERACTIVE_ANALYSIS_MODAL);
        return [...kept, ...narrowedSteps.slice(narrowedIndex + 1).filter(isStepStillWanted)];
    }
    recomputeWizardSteps(narrowing) {
        this.isRecomputingWizardSteps = true;
        this.wizardStepsSubscription = narrowing.steps$.subscribe({
            next: (narrowedSteps) => {
                this.isRecomputingWizardSteps = false;
                if (!this.modalOpen) {
                    return;
                }
                this.hasNarrowedWizardSteps = narrowing.isNarrowed;
                this.store.dispatch(setSelectedReportWizardSteps({ wizardSteps: this.mergeWizardSteps(narrowedSteps) }));
                this.store.dispatch(incrementCurrentWizardStep());
                this.finishWizardStep();
            },
            error: () => {
                this.isRecomputingWizardSteps = false;
                if (!this.modalOpen) {
                    return;
                }
                this.wizardStepsError = true;
            },
        });
    }
    finishWizardStep() {
        this.broadcastWizardStepEvent.emit();
        this.closeModal();
    }
}
SelectSectionsModalComponent.ɵfac = function SelectSectionsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectSectionsModalComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.CustomPDFReportService), i0.ɵɵdirectiveInject(i3.CustomPDFReportModulePreviewImageService)); };
SelectSectionsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectSectionsModalComponent, selectors: [["ycn-select-sections-modal"]], viewQuery: function SelectSectionsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sectionsContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.orphanModulesHelpTrigger = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reorderButtons = _t);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 37, vars: 20, consts: [["orphanModulesHelpTrigger", ""], ["sectionsContainer", ""], ["reorderButton", ""], [3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "resetModalHandler", "header", "resetModalText"], [1, "modal-body"], [1, "modal-section", "pb-10"], [1, "table", "file-table"], [1, "thead"], [1, "tr"], [1, "td", "col-10", "border-0"], [1, "d-inline-block", "pb-10", "pt-12", "text-bold"], [1, "td", "col-2", "border-0", "text-right", "text-nowrap"], ["modalName", "section_reorder_orphan_modules_warning", "triggerLabel", "(?)"], [1, "tbody"], [1, "tr", "section-row"], [1, "modal-footer"], [1, "text-red"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [1, "btn", "btn-secondary"], ["ycnTooltip", "", 3, "tooltipPlacement", "tooltipTitle"], ["ycnDisabled", "", 1, "btn", "btn-secondary", "ml-1", 3, "click", "disabled"], ["ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], [1, "ml-1"], [3, "closeModalHandler", "open", "loading", "error", "modules", "reportOrientation"], ["aria-live", "polite", 2, "position", "absolute", "width", "1px", "height", "1px", "overflow", "hidden", "clip", "rect(0 0 0 0)", 3, "textContent"], [1, "text-muted"], [1, "td", "col-11"], ["ycnTooltip", "", 1, "custom-control", "custom-checkbox", 3, "tooltipPlacement", "tooltipTitle"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "disabled", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "td", "col-1", "text-right"], ["type", "button", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up", 3, "active", "backgroundColor", "outline", "tooltipTitle"], ["type", "button", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up", 3, "keydown", "focus", "blur", "tooltipTitle"], ["ycnIcon", "", 3, "name"], ["href", "javascript:void(0)", 3, "click"], [1, "btn", "btn-secondary", 3, "click"], [1, "loader-spinner-context", "loader-xs"]], template: function SelectSectionsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 3);
        i0.ɵɵlistener("closeModalHandler", function SelectSectionsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 4);
        i0.ɵɵlistener("closeModalHandler", function SelectSectionsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); })("resetModalHandler", function SelectSectionsModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.restoreDefaults()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 5);
        i0.ɵɵconditionalCreate(3, SelectSectionsModalComponent_Conditional_3_Template, 3, 0, "div", 6);
        i0.ɵɵelementStart(4, "div", 6)(5, "div", 7)(6, "div", 8)(7, "div", 9)(8, "div", 10)(9, "span", 11);
        i0.ɵɵtext(10, "Name");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "div", 12)(12, "span", 11);
        i0.ɵɵtext(13, "Order");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(14, "\u00A0");
        i0.ɵɵelement(15, "ycn-help-modal-with-trigger", 13, 0);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(17, "div", 14, 1);
        i0.ɵɵrepeaterCreate(19, SelectSectionsModalComponent_For_20_Template, 8, 7, "div", 15, _forTrack0);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(21, "div", 16);
        i0.ɵɵconditionalCreate(22, SelectSectionsModalComponent_Conditional_22_Template, 2, 0, "span", 17);
        i0.ɵɵconditionalCreate(23, SelectSectionsModalComponent_Conditional_23_Template, 2, 0, "span", 17);
        i0.ɵɵconditionalCreate(24, SelectSectionsModalComponent_Conditional_24_Template, 4, 0, "span", 17);
        i0.ɵɵelementStart(25, "div", 18)(26, "div", 19);
        i0.ɵɵlistener("click", function SelectSectionsModalComponent_Template_div_click_26_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(27, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(28, SelectSectionsModalComponent_Conditional_28_Template, 2, 0, "div", 20);
        i0.ɵɵelementStart(29, "span", 21)(30, "div", 22);
        i0.ɵɵlistener("click", function SelectSectionsModalComponent_Template_div_click_30_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.preview()); });
        i0.ɵɵtext(31, "Preview");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(32, "div", 23);
        i0.ɵɵlistener("click", function SelectSectionsModalComponent_Template_div_click_32_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵtext(33, " Next ");
        i0.ɵɵconditionalCreate(34, SelectSectionsModalComponent_Conditional_34_Template, 2, 0, "div", 24);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(35, "ycn-preview-sections-modal", 25);
        i0.ɵɵlistener("closeModalHandler", function SelectSectionsModalComponent_Template_ycn_preview_sections_modal_closeModalHandler_35_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closePreview()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(36, "div", 26);
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Sections")("resetModalText", ctx.restoreDefaultsButtonText);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.allowSectionOrdering ? 3 : -1);
        i0.ɵɵadvance(16);
        i0.ɵɵrepeater(ctx.sections);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.submitError ? 22 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.wizardStepsError ? 23 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.preferenceFetchError ? 24 : -1);
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.currentWizardStepIndex ? 28 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("tooltipPlacement", "top")("tooltipTitle", ctx.previewDisabledReason);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", !!ctx.previewDisabledReason || ctx.isLoadingPreference);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.isSubmitting || ctx.isLoadingPreference || ctx.preferenceFetchError || ctx.isRestoringDefaults || ctx.isRecomputingWizardSteps);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isSubmitting || ctx.isRecomputingWizardSteps ? 34 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("open", ctx.previewOpen)("loading", ctx.previewLoading)("error", ctx.previewError)("modules", ctx.previewModules)("reportOrientation", ctx.reportOrientation);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.liveMessage);
    } }, dependencies: [i4.DisabledDirective, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgModel, i6.HelpModalWithTriggerComponent, i7.IconDirective, i8.ModalBaseComponent, i9.SimpleModalHeaderComponent, i10.TooltipDirective, i11.PreviewSectionsModalComponent], encapsulation: 2 });
